import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { INITIAL_PROMO_CODE } from '../Constants/RetreatConfig';
import '../Styles/RetreatJoinGroup.scss';
import DataAccessHelper from '../Helper/DataAccessHelper';

function RetreatJoinGroup({ groupJoined, setGroupJoined, week, setSelectedPage, nextPage, previousPage,
   reservationInfo, setReservationInfo, setIsInGroup, setPromoCode }) {

   const [groupCode, setGroupCode] = useState('');
   const [groupExpanded, setGroupExpanded] = useState(false);
   const [groupSearchResponse, setGroupSearchResponse] = useState('No Search Yet');
   const [noSlotsError, setNoSlotsError] = useState(false);
   const navigate = useNavigate();

   // Fast track promos are validated against the group the registrant selected, so returning to
   // this step has to clear any code already applied. Resetting in an effect rather than during
   // render — the previous version set parent state mid-render and overwrote the promo object
   // with a boolean, which silently dropped the discount downstream.
   useEffect(() => {
      setPromoCode(INITIAL_PROMO_CODE)
   }, [])

   async function groupSearch() {
      try {
         const groupRequest = await fetch('/searchgroup', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ groupCode, eventId: week.event_id })
         })
         const groupResponse = await groupRequest.json();
         const response = groupResponse.data.searchGroupQuery.rows[0];
         if (!response) {
            setGroupSearchResponse(null);
            setIsInGroup(false);
         } else {
            setGroupSearchResponse(response);
            setIsInGroup(true);
         }
      } catch (error) {
         console.log(error)
      }
   }

   async function handleGroupSelection() {
      try {
         setGroupJoined(groupSearchResponse);
         const reservationId = groupSearchResponse.reservation_id;
         let numberOfSlots = 0;

         if (groupSearchResponse.is_fast_track) {
            const ftResponse = await DataAccessHelper.getFastTrackInformation(reservationId);
            numberOfSlots = ftResponse.data.eventInfo[0].slots_reserved;
            setReservationInfo(ftResponse.data.eventInfo[0]);
         } else {
            const stdResponse = await DataAccessHelper.getStandardReservationInformation(reservationId);
            numberOfSlots = stdResponse.data.eventInfo[0].slots_reserved;
            setReservationInfo(stdResponse.data.eventInfo[0]);
         }

         if (numberOfSlots < 1 && week.number_of_slots < 1) {
            setNoSlotsError(true);
         } else {
            setSelectedPage(nextPage);
         }
      } catch (error) {
         console.log(error)
      }
   }

   function handleIndividualSelection() {
      setGroupJoined(null);
      if (week.number_of_slots < 1) {
         setNoSlotsError(true);
      } else {
         setSelectedPage(nextPage);
      }
   }

   return (
      <div className="RetreatJoinGroupContainer">
         <div className="RetreatJoinGroupContent">
            <div className="RetreatJoinGroupHeading">
               Continue Registration
            </div>

            {/* Primary action — most users take this path */}
            <div className="RetreatJoinGroupPrimaryAction">
               <button onClick={handleIndividualSelection}>
                  Continue as Individual
               </button>
            </div>

            <div className="RetreatJoinGroupDivider">
               Attending with a group?
            </div>

            {/* Secondary collapsible section for group joining */}
            <div className="RetreatJoinGroupSecondary">
               <button
                  className="RetreatJoinGroupSecondaryToggle"
                  onClick={() => setGroupExpanded(prev => !prev)}
               >
                  Enter a group code
                  <span>{groupExpanded ? '▲' : '▼'}</span>
               </button>

               {groupExpanded && (
                  <div className="RetreatJoinGroupSecondaryBody">
                     <label>Group Code</label>
                     <div className="RetreatGroupCodeRow">
                        <input
                           type="text"
                           maxLength={8}
                           value={groupCode}
                           onChange={(e) => setGroupCode(e.target.value)}
                           placeholder="e.g. ABCD1234"
                        />
                        <button onClick={groupSearch}>Search</button>
                     </div>

                     {groupSearchResponse === null && (
                        <div className="RetreatJoinGroupNotFound">
                           Group not found. Please check the code and try again.
                        </div>
                     )}

                     {groupSearchResponse !== null && groupSearchResponse !== 'No Search Yet' && (
                        <div className="RetreatJoinGroupFoundGroup">
                           <span>
                              {groupSearchResponse.group_name}, {groupSearchResponse.group_city} {groupSearchResponse.group_state}
                           </span>
                           <button onClick={handleGroupSelection}>Join</button>
                        </div>
                     )}

                     {noSlotsError && (
                        <div className="RetreatJoinGroupErrorFull">
                           This retreat is full.
                           <button onClick={() => navigate('/individualaccount')}>Exit</button>
                        </div>
                     )}
                  </div>
               )}
            </div>

            <div className="RetreatJoinGroupButtonsContainer">
               <div className="RetreatJoinGroupButtons">
                  <div className="RetreatJoinGroupPreviousButton">
                     <button onClick={() => setSelectedPage(previousPage)}>
                        Previous
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default RetreatJoinGroup;
